import _ from 'lodash';
import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { DataManagementContext } from '../../components/viewers/DataManagementViewer';
import { gEnums } from '../../enums/globalEnums';
import { getRefPropz } from '../../firestoreData/helpers/getRefProps';
import { _animateTypes } from '../../motions/AnimateComponent';
import MotionComponent from '../../motions/MotionComponent';
import { dataHandlers, dataInitialState, dataReducer } from '../reducers/DataReducer';
import { AppComponentContext } from './AppComponentContext';
import { DemoContext } from './DemoContext';
import { FrameworkContext } from './FrameworkContent';
import { GoogleSheetsContext } from './GoogleSheetsContext';
import { PageDataContext } from './PageDataContext';
import { ParentContext } from './ParentContext';
import { ViewSettingsContext } from './ViewSettingsContext';
import { useItemData } from './useHelpers/useItemData';
import { useAppUserAccess } from './useHelpers/useAppUserAccess';

/** gets the data for the uiItem.
 @returns viewListData,  
 @returns confirmation,  
*/
export const DataContext = createContext();

const DataProvider = (props) => {

  const {
    diKey,
    fieldProps,
    forAppViewer,
    isSettingData,
    itemListData,
    uivi,
    updateProps,
  } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers, fns, settings } = parentContext ?? {}

  const {
    currentSettings_state,
    appData_state,
    appSettings_state,
    eventInfo_state,
    page_state,
    paps_state,
    preview_state,
    serviceWorker_state,
    storage_state,
    transition_state,
  } = states


  const { aps_global, aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  const { appUser_handlers, appData_handlers } = handlers
  const { database_fns } = fns ?? {}
  const { tempDataSource } = appSettings_state ?? {}
  const { previews } = preview_state ?? {}
  const { dataConstraints: dataConstraints_preview } = previews ?? {}

  // papsContext  
  const { pathViews, view, viewKey, eventPageKey, showStatus } = paps_state ?? {}

  // serviceWorkerContext 
  // const { cache_info } = serviceWorker_state ?? {}
  // const { cache_groups } = cache_info ?? {}
  // const { cache_event } = cache_groups ?? {}

  // googleSheetsContext
  // const demoContext = useContext(DemoContext)
  // const { demo_state } = demoContext ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_state } = googleSheetsContext ?? {}

  // authContext  
  // const appUserAccess = useAppUserAccess()
  // const { isSuperAdmin } = appUserAccess ?? {}

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext)
  const { framework_state, framework_handlers } = frameworkContext
  const { tempSettings } = framework_state ?? {}
  const _tempSettings_vi = tempSettings && tempSettings[uivi]
  // const { dataConstraints: dataConstraints_temp } = _tempSettings_vi ?? {}

  // transitionContext  
  const { transitions } = transition_state ?? {}
  const transition = transitions ? transitions[_animateTypes.data] : null
  const { showTransition } = transition ?? {}

  // storageContext 
  const { pageItemImages } = storage_state ?? {}
  const pageImages = pageItemImages && pageItemImages[view] ? pageItemImages[view] : {}

  // viewSettingsSwipeContext - THIS has all the info
  const viewSettingsContext = useContext(ViewSettingsContext);
  const { viewSettings_state } = viewSettingsContext ?? {}
  const { settingsStatus } = viewSettings_state ?? {}

  // pageContext  
  const { dataOptions, appDataSource, display } = aps_global ?? {}
  const { useStartDataCollections, getAllDataCollections, appDataSourceType, autoUpdateAppDataLinks, autoUpdateAppDataDocuments, autoUpdateStaticViews } = appDataSource ?? {}
  const { onDemand, hideInactiveItems: hideInactiveItems_do } = dataOptions ?? {}
  let { timeZone } = display ?? {}
  const { menu, viewItems: viewItems_page } = aps_page ?? {}
  const _useStartDataCollections = useStartDataCollections && getAllDataCollections

  // pageDataContext
  const pageDataContext = useContext(PageDataContext);
  const { pageData_state, pageData_handlers } = pageDataContext ?? {}
  const { currentPageData } = pageData_state ?? {}

  // appContext
  const appContext = useContext(AppComponentContext)
  const { appComponent: appComponent_context } = appContext ?? {}

  // eventInfoContext 
  const { globalAppData } = appData_state ?? {}

  // eventInfoContext 
  const { staticViews, eventCollectionsData, appDataLinks, appDataDocuments, cache_eventInfo } = eventInfo_state ?? {}

  // googleSheetsContext 
  const { googleModeType, googleSheetsData, staticViews: staticViews_gs, googlePreviewType } = googleSheets_state ?? {}

  // dataManagementContext
  const dataManagementContext = useContext(DataManagementContext)
  const { dataManagement_state } = dataManagementContext ?? {}
  const { viewItem_preview } = dataManagement_state ?? {}

  const _appDataSourceType = tempDataSource ? tempDataSource : appDataSourceType

  // test for other settings
  let isCombinedData = false
  let cbnVis = {}
  let returnFsr;

  let viewItem_page = viewItems_page ? viewItems_page[uivi] : {}

  if (viewItem_preview) {
    viewItem_page = viewItem_preview
    returnFsr = true
  }

  const { combinedGroups, dataConstraints, dataSource, grouping, } = viewItem_page ?? {}

  const { dataSourceType: dataSourceType_page, pageDataCollection, appComponent, appComponentStateCollection, dataCollectionName, dataCollectionNames } = dataSource ?? {}
  // const { usePostDataConstraint, usePostAppUserPageConstraint, usePostAppUserDataConstraint, usePostPageConstraint } = dataConstraints ?? {}
  // const _usePostConstraint = usePostDataConstraint || usePostAppUserPageConstraint || usePostAppUserDataConstraint || usePostPageConstraint

  // const { fetchByAlphabet } = grouping ?? {}

  if (combinedGroups) {
    cbnVis[viewItem_page.key] = viewItem_page
    Object.keys(combinedGroups).forEach(key => {
      cbnVis[key] = combinedGroups[key]
    })
    isCombinedData = true
  }

  let viewItem_g;
  if (aps_viewItems && aps_viewItems[uivi]) { viewItem_g = aps_viewItems[uivi] }
  const { dataConnection } = viewItem_g ?? {}
  const { dataSourceType: dataSourceType_pageGlobal, documentDependencies, altCollectionName } = dataConnection ?? {}

  // const _dataSourceType = useMemo(() => {
  //   // the the page does not have a dataSourceType, use the global
  //   let _dataSourceType_page = dataSourceType_page ? dataSourceType_page : dataSourceType_pageGlobal

  //   if (!_dataSourceType_page) { _dataSourceType_page = _appDataSourceType }

  //   switch (_appDataSourceType) {
  //     case gEnums.dataSourceTypes.googleSheet:
  //       _dataSourceType_page = _appDataSourceType
  //       break;
  //     default:
  //     // nothing
  //   }

  //   return _dataSourceType_page
  // }, [dataSourceType_page, dataSourceType_pageGlobal, _appDataSourceType])

  // const _dataSourceType = getDataSourceType()

  let dataCollection = uivi
  let trueViewKey = viewKey

  if (altCollectionName) {
    dataCollection = altCollectionName
    trueViewKey = null
  }

  let delayData = onDemand ? true : false

  // IMPORTANT: Data - Get the data for the viewItem
  const dataInit_state = {
    database_fns,
    diKey,
    isCombinedData,
    isSettingData,
    itemListData,
    pageImages,
    uivi,
    updateProps,
    viewItem: viewItem_page,
  }

  const [data_state, data_dispatch] = useReducer(dataReducer, dataInitialState(dataInit_state));

  const data_handlers = useMemo(
    () => dataHandlers(data_dispatch),
    [data_dispatch]
  );

  const { itemDataInfo } = useItemData({ dataInit_state })

  useEffect(() => {
    if (itemDataInfo) {
      data_handlers.handleLoad_itemData(itemDataInfo)
      pageData_handlers && pageData_handlers.handleItemDataCounts(itemDataInfo.itemDataName, itemDataInfo.itemDataName, _.size(itemDataInfo?.itemData))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemDataInfo]);

  const { dataResults, alphaValue, alphabetValue, fetchData } = data_state ?? {}

  if (onDemand && alphaValue) { delayData = false }

  let viewListData = (data_state && dataCollection && data_state[dataCollection]) ? data_state[dataCollection] : null

  if (showStatus && viewListData) { console.log('data_state ready', dataCollection, data_state) }


  useEffect(
    () => {
      if (dataResults) {

        const { _postData, dataValue, dataResultProps, missingSvData, refProps, dataCollection, existingDatas } = dataResults

        framework_handlers.handleAmmend_dataOrigin(existingDatas)

        const { name: _dataCollectionName } = dataResultProps ?? {}

        const _dataConstraints = dataConstraints_preview ? dataConstraints_preview : dataConstraints
        const { includeInAppUserData } = _dataConstraints ?? {}
        const { refKey } = refProps ?? {}

        if (refKey) {
          // dataCollection, refKey, data, missingSvData 
          appData_handlers.handleSet_appData(pathViews, dataCollection, view, viewKey, eventPageKey, refKey, dataValue, missingSvData)
        }

        // add this dataValue to the appUser page data
        if (includeInAppUserData && appUser_handlers && appUser_handlers.handleAppUserPageData) {
          appUser_handlers.handleAppUserPageData(_dataCollectionName, dataValue)
        }

        if (pageData_handlers) {
          pageData_handlers && pageData_handlers.handleItemDataCounts(uivi, _dataCollectionName, _postData ? Object.keys(_postData).length : 0)
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [dataResults]
  )

  const viewDataProviderContext = () => <DataContext.Provider value={{ data_state, data_handlers }}>
    {props.children}
  </DataContext.Provider>

  const itemDataProviderContext = () => <DataContext.Provider value={{ data_state, data_handlers }}>
    {props.children}
  </DataContext.Provider>

  const content = () => {
    if (viewItem_page && viewListData) {
      return viewDataProviderContext()
    } else if (itemListData) {
      return itemDataProviderContext()
    } else {
      if (forAppViewer && viewListData) {
        return viewDataProviderContext()
      } else {
        if (dataSourceType_page === gEnums.dataSourceTypes.component) {
          return itemDataProviderContext()
        } else {
          return <div>{`🕒`}</div>
        }
      }
    }
  }

  if (showTransition) {
    return <MotionComponent transition={transition}>
      {content()}
    </MotionComponent>
  } else {
    return content()
  }
}

export default DataProvider
